import { combineReducers } from '@reduxjs/toolkit';
import { vaultsSlice } from 'src/store/DEX/Vaults/slice';
import storage from 'src/store/storage';
import { persistReducer } from 'redux-persist';
import {
  DEX_TRANSACTION_FILTER_PERSIST_CONFIG,
  dexTransactionFilterSlice,
} from '@skynet/data-dex-transactions';
import vaultListFilterReducer from 'src/store/DEX/Vaults/filterSlice';
import { DEX_TASK_FILTER_PERSIST_CONFIG, dexTaskFilterSlice } from '@skynet/data-dex-tasks-filter';

const persistedConfig = {
  key: 'vault/sidebar',
  version: 1,
  storage,
  whitelist: ['sortKey'],
};

export default combineReducers({
  vaults: persistReducer(persistedConfig, vaultsSlice.reducer),
  transactions: combineReducers({
    filter: persistReducer(
      { ...DEX_TRANSACTION_FILTER_PERSIST_CONFIG, storage },
      dexTransactionFilterSlice.reducer,
    ),
  }),
  vaultList: vaultListFilterReducer,
  tasks: combineReducers({
    filter: persistReducer(
      { ...DEX_TASK_FILTER_PERSIST_CONFIG, storage },
      dexTaskFilterSlice.reducer,
    ),
  }),
});
